<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <div class="vendor-form-wrapper">
      <div class="vendor-form">
        <p class="vendor-form-label">
          Alamat Sesuai
          {{
            this.$store.state.landingpage.query == 'bu'
              ? 'Faktur Pajak'
              : 'KTP'
          }}<span class="text-ast">*</span>
        </p>
        <textarea
          class="vendor-input"
          v-model="address"
          autocomplete="alamat"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
        />
      </div>

      <div class="vendor-form">
        <div class="vendor-form-label">
          Negara<span class="text-ast">*</span>
        </div>
        <div class="vendor-input">
          <v-select
            class="style-chooser"
            placeholder="Pilih Negara"
            label="negara"
            :options="countries"
            v-model="choosedCountry"
            autocomplete="negara"
          />
        </div>
      </div>
      <div class="vendor-form" v-if="choosedCountry && choosedCountry.id == 63">
        <div class="vendor-form-label">
          Provinsi<span class="text-ast">*</span>
        </div>
        <div class="vendor-input">
          <v-select
            class="style-chooser"
            placeholder="Pilih Provinsi"
            label="desc"
            :options="provinces"
            v-model="choosedProvince"
          />
        </div>
      </div>
      <div class="vendor-form" v-if="choosedProvince">
        <div class="vendor-form-label">Kota<span class="text-ast">*</span></div>
        <div class="vendor-input">
          <v-select
            class="style-chooser"
            placeholder="Pilih Kota"
            label="desc"
            :options="cities"
            v-model="choosedCity"
            autocomplete="kota"
          />
        </div>
      </div>
      <div class="vendor-form" v-if="choosedCity">
        <div class="vendor-form-label">
          Kecamatan<span class="text-ast">*</span>
        </div>
        <div class="vendor-input">
          <v-select
            class="style-chooser"
            placeholder="Pilih Kecamatan"
            label="desc"
            :options="districs"
            v-model="choosedDistric"
          />
        </div>
      </div>
      <div class="vendor-form" v-if="choosedDistric">
        <div class="vendor-form-label">
          Kelurahan<span class="text-ast">*</span>
        </div>
        <div class="vendor-input">
          <v-select
            class="style-chooser"
            placeholder="Pilih Kelurahan"
            label="desc"
            :options="villages"
            v-model="choosedVillage"
          />
        </div>
      </div>

      <div
        class="vendor-form"
        v-if="choosedCountry && choosedCountry.id !== 63"
      >
        <p class="vendor-form-label">Provinsi<span class="text-ast">*</span></p>
        <input
          type="text"
          class="vendor-input"
          v-model="provinsiAsing"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
        />
      </div>
      <div
        class="vendor-form"
        v-if="choosedCountry && choosedCountry.id !== 63"
      >
        <p class="vendor-form-label">Kota<span class="text-ast">*</span></p>
        <input
          type="text"
          class="vendor-input"
          v-model="kotaAsing"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
        />
      </div>

      <div class="vendor-form">
        <p class="vendor-form-label">Kode Pos<span class="text-ast">*</span></p>
        <the-mask
          class="vendor-input"
          :mask="['######']"
          placeholder="Isikan kodepos"
          v-model="kodepos"
        />
      </div>

      <div class="vendor-form">
        <p class="vendor-form-label">
          No. Handphone<span class="text-ast">*</span>
        </p>
        <div class="phone-input">
          <the-mask
            class="phone-input__code"
            :mask="['+###']"
            v-model="phoneCode"
          />
          <the-mask
            class="phone-input__phone"
            :mask="['####################']"
            v-model="phoneNumber"
          />
        </div>
      </div>

      <div class="vendor-form">
        <p class="vendor-form-label">Email<span class="text-ast">*</span></p>
        <input
          type="text"
          class="vendor-input"
          v-model="emailPerusahaan"
          autocomplete="email"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
        />
      </div>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goBank()" class="btn-landing">Selanjutnya</div>
    </div>
  </div>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  name: 'alamat',
  data() {
    return {
      countries: [],
      provinces: [],
      cities: [],
      districs: [],
      villages: [],
    }
  },
  created() {
    this.getCountry()
    this.getProvince()
  },
  computed: {
    provinsiAsing: {
      get() {
        return this.$store.state.landingpage.provinsiAsing
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'provinsiAsing',
          value: newValue,
        })
      },
    },
    kotaAsing: {
      get() {
        return this.$store.state.landingpage.kotaAsing
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kotaAsing',
          value: newValue,
        })
      },
    },
    choosedCountry: {
      get() {
        return this.$store.state.landingpage.choosedCountry
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedCountry',
          value: newValue,
        })

        if (newValue) {
          if (newValue.id == 63) {
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phoneCode',
              value: '+62',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'mataUang',
              value: 'IDR',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phoneDirektur',
              value: '+62',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phoneKomisaris',
              value: '+62',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phonePic',
              value: '+62',
            })
          }
        } else {
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'choosedProvince',
            value: null,
          })
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'choosedCity',
            value: null,
          })
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'choosedDistric',
            value: null,
          })
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'choosedVillage',
            value: null,
          })
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'kodepos',
            value: '',
          })
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'phoneCode',
            value: '',
          })
        }
      },
    },
    choosedProvince: {
      get() {
        return this.$store.state.landingpage.choosedProvince
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedProvince',
          value: newValue,
        })
      },
    },
    choosedCity: {
      get() {
        if (this.$get(this.$store, 'state.landingpage.choosedProvince.id')) {
          this.getCity()
        }
        return this.$store.state.landingpage.choosedCity
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedCity',
          value: newValue,
        })
      },
    },
    choosedDistric: {
      get() {
        if (this.$get(this.$store, 'state.addEdit.choosedCity.id')) {
          this.getDistric()
        }
        return this.$store.state.landingpage.choosedDistric
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedDistric',
          value: newValue,
        })
      },
    },
    choosedVillage: {
      get() {
        if (this.$get(this.$store, 'state.addEdit.choosedDistric.id')) {
          this.getVillage()
        }
        return this.$store.state.landingpage.choosedVillage
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedVillage',
          value: newValue,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kodepos',
          value: newValue ? newValue.kodepos : '',
        })
      },
    },
    kodepos: {
      get() {
        return this.$store.state.landingpage.kodepos
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kodepos',
          value: newValue,
        })
      },
    },
    phoneCode: {
      get() {
        return this.$store.state.landingpage.phoneCode
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'phoneCode',
          value: newValue,
        })
      },
    },
    phoneNumber: {
      get() {
        return this.$store.state.landingpage.phoneNumber
      },
      set: function(newValue) {
        // let input = newValue
        // input = input.replace(/[\W\s\._\-]+/g, '')

        // let split = 0
        // let chunk = []

        // for (let i = 0; i < input.length; i += split) {
        //   split = i < 3 ? 3 : i < 5 ? 4 : 5
        //   chunk.push(input.substr(i, split))
        // }

        // let newPhoneNumber = chunk.join(' ')
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'phoneNumber',
          value: newValue,
        })
      },
    },
    emailPerusahaan: {
      get: function() {
        return this.$store.state.landingpage.emailPerusahaan
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'emailPerusahaan',
          value: newValue,
        })
      },
    },
    address: {
      get: function() {
        return this.$store.state.landingpage.address
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'address',
          value: newValue,
        })
      },
    },
  },
  watch: {
    choosedCountry: function(newValue, oldValue) {
      if (newValue && newValue.id == 63) {
        this.provinsiAsing = null
        this.kotaAsing = null
        this.kodepos = null
      }
    },
    choosedProvince: function(newValue, oldValue) {
      if (newValue !== oldValue && newValue == null) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedProvince',
          value: newValue,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedCity',
          value: null,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedDistric',
          value: null,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedVillage',
          value: null,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kodepos',
          value: null,
        })
      } else {
        this.getCity()
      }
    },
    choosedCity: function(newChoosedCity, oldChoosedCity) {
      if (newChoosedCity !== oldChoosedCity && newChoosedCity == null) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedCity',
          value: newChoosedCity,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedDistric',
          value: null,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedVillage',
          value: null,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kodepos',
          value: null,
        })
      } else {
        this.getDistric()
      }
    },
    choosedDistric: function(newChoosedDistric, oldChoosedDistric) {
      if (
        newChoosedDistric !== oldChoosedDistric &&
        newChoosedDistric == null
      ) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedDistric',
          value: newChoosedDistric,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'choosedVillage',
          value: null,
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kodepos',
          value: null,
        })
      } else {
        this.getVillage()
      }
    },
    choosedVillage: function(newChoosedVillage, oldChoosedVillage) {
      if (
        newChoosedVillage !== oldChoosedVillage &&
        newChoosedVillage == null
      ) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'kodepos',
          value: '',
        })
      }
    },
  },
  methods: {
    checkForm() {
      let arr = [
        [this.address, 'Alamat'],
        [this.choosedCountry, 'Negara'],
        [this.phoneCode, 'Kode Negara'],
        [this.kodepos, 'Kode Pos'],
        [this.phoneNumber, 'Nomor Telepon'],
        [this.isEmailValid(this.emailPerusahaan), 'Email'],
      ]

      if (this.choosedCountry && this.choosedCountry.id == 63) {
        arr = [
          ...arr,
          [this.choosedProvince, 'Provinsi'],
          [this.choosedCity, 'Kota'],
          [this.choosedDistric, 'Kecamatan'],
          [this.choosedVillage, 'Kelurahan'],
        ]
      } else {
        arr = [
          ...arr,
          [this.provinsiAsing, 'Provinsi'],
          [this.kotaAsing, 'Kota'],
        ]
      }

      if (
        this.$get(this.$store, 'state.landingpage.type_pendaftaran_id') == 1
      ) {
        return this.multiConditions(arr)
      }
      return true
    },
    goBack() {
      const query = this.$store.state.landingpage.query
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'profilebu')
    },
    goBank() {
      if (this.checkForm()) {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'bank')
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'bank_step',
          value: true,
        })
      }
    },
    async getCountry() {
      const url = `${api}/api/v1/negara?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.countries = data.data
      } catch (error) {}
    },
    async getProvince() {
      const url = `${api}/api/v1/provinsi?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.provinces = data.data
      } catch (error) {}
    },
    async getCity() {
      const url = `${api}/api/v1/kota?page=1&limit=1000&provinsi=${this.$get(
        this.$store,
        'state.landingpage.choosedProvince.id'
      )}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.cities = data.data
      } catch (error) {}
    },
    async getDistric() {
      const url = `${api}/api/v1/kecamatan?page=1&limit=10000&kota=${this.$get(
        this.$store,
        'state.landingpage.choosedCity.id'
      )}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.districs = data.data
      } catch (error) {}
    },
    async getVillage() {
      const url = `${api}/api/v1/kelurahan?page=1&limit=1000&kecamatan=${this.$get(
        this.$store,
        'state.landingpage.choosedDistric.id'
      )}`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.villages = data.data
      } catch (error) {}
    },
  },
}
</script>
